import React from 'react';
import RuleLink from '../components/RuleLink';

/**
 * Подтверждение каскадного выключения детекции (Part 4, раздел 4.2).
 *
 * Действие не блокируется окончательно: администратор вправе выключить
 * детекцию, но обязан увидеть, какие правила при этом станут неактивными.
 * Оптимистичного успеха здесь быть не может — правила деактивирует backend,
 * и только его ответ считается результатом.
 */
const DetectorDependencyConfirmModal = ({
  featureName,
  dependentRules = [],
  busy = false,
  error = '',
  title,
  intro,
  confirmLabel,
  onConfirm,
  onCancel,
}) => (
  <>
    <div className="vio-modal-overlay" onClick={busy ? undefined : onCancel} />
    <div className="vio-modal" role="dialog" aria-label="Отключение детекции">
      <h3 className="vio-modal-title">{title || `Отключить детекцию «${featureName}»?`}</h3>

      <p className="vio-modal-text">
        {intro || `Детекция «${featureName}» используется активными правилами:`}
      </p>

      <ul className="vio-modal-list">
        {dependentRules.map((rule) => (
          <li key={rule.rule_id}><RuleLink rule={rule} /></li>
        ))}
      </ul>

      <p className="vio-modal-text">
        При отключении детекции эти правила будут деактивированы.
      </p>

      {error && <p className="vio-field-error">{error}</p>}

      <div className="vio-modal-actions">
        <button type="button" className="vio-btn" disabled={busy} onClick={onCancel}>
          Отмена
        </button>
        <button type="button" className="vio-btn vio-btn--danger" disabled={busy} onClick={onConfirm}>
          {busy ? 'Отключаем…' : (confirmLabel || 'Выключить детекцию и правила')}
        </button>
      </div>
    </div>
  </>
);

export default DetectorDependencyConfirmModal;
